"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegClass = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const axios_1 = __importDefault(require("axios"));
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
class RegClass {
    constructor() {
        this._url = 'https://bot.dewallet.pro/';
    }
    async post(url, data) {
        try {
            const res = await axios_1.default.post(`${this._url}${url}`, data);
            return res.data;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    async postAuth(address) {
        const res = await this.post('auth', { tg_data: sdk_1.default.initData, address });
        return res;
    }
}
exports.RegClass = RegClass;
